/**
 * Account Settings - Using Clerk UserProfile
 *
 * Clerk handles all user profile management (name, email, password, etc.)
 */

import { UserProfile } from '@clerk/clerk-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { User } from 'lucide-react';

export default function AccountSettings() {
  return (
    <div className="space-y-6">
      <Card className="border-0 shadow-none bg-transparent">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <User className="h-5 w-5" />
            Your Profile
          </CardTitle>
          <CardDescription>
            Manage your account settings, email, and password
          </CardDescription>
        </CardHeader>
        <CardContent>
          <UserProfile
            routing="hash"
            appearance={{
              variables: {
                // BUG-004 FIX: Use Clerk's colorPrimary variable for button background
                colorPrimary: '#148068', // hsl(166, 76%, 32%) - matches --accent
                colorPrimaryText: '#ffffff',
              },
              elements: {
                rootBox: 'w-full',
                card: 'shadow-none border-0 p-0 bg-transparent',
                cardBox: 'shadow-none border-0',
                navbar: 'hidden',
                pageScrollBox: 'p-0',
                page: 'p-0',
                profilePage: 'p-0',
                profileSection: 'border-border/30',
                profileSectionTitleText: 'text-foreground font-semibold',
                formFieldInput:
                  'bg-muted/30 border-border/50 focus:bg-background focus:border-accent/50',
                formButtonPrimary: 'shadow-md',
              },
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
